import { Field } from 'formik';
import React from 'react';
import { InputTextWithValidationMessageAndToolip } from '../../../components/prime-formik';
import { buildVatIdExampleText } from '../../../utils/AppUtil';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  vatIdTooltip: { id: 'attrs.vatId.tooltip', defaultMessage: 'The value of VAT/GST ID' },
  vatId: { id: 'attrs.vatId', defaultMessage: 'VAT/GST ID' },
  vatIdPlaceholder: { id: 'attrs.vatIdPlaceholder', defaultMessage: 'Example: {vatIdExample}' },
});

const TaxIdInput = ({ selectedTaxId }) => {
  const { formatMessage } = useIntl();

  const vatIdPlaceholderExample = buildVatIdExampleText(selectedTaxId);

  return (
    <div className="p-col-12">
      <Field
        name="company.taxId"
        labelText={formatMessage(messages.vatId)}
        placeholderText={formatMessage(messages.vatIdPlaceholder, { vatIdExample: vatIdPlaceholderExample })}
        tooltipText={formatMessage(messages.vatIdTooltip)}
        component={InputTextWithValidationMessageAndToolip}
      />
    </div>
  );
};

export default TaxIdInput;
